import { render } from "./AccountLocations.vue?vue&type=template&id=4c7aef4a&scoped=true"
import script from "./AccountLocations.vue?vue&type=script&lang=js"
export * from "./AccountLocations.vue?vue&type=script&lang=js"

import "./AccountLocations.vue?vue&type=style&index=0&id=4c7aef4a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7aef4a"]])

export default __exports__